module.exports = __webpack_public_path__ + "assets/images/USD50.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USD50.png
// module id = 1457
// module chunks = 1